"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtFromPath = exports.getStreamType = void 0;
var constants_1 = require("../../../constants");
var extensionsMap = Object.create(null);
extensionsMap.mp4 = constants_1.MediaStreamType.MP4;
extensionsMap.webm = constants_1.MediaStreamType.WEBM;
extensionsMap.m3u8 = constants_1.MediaStreamType.HLS;
extensionsMap.mpd = constants_1.MediaStreamType.DASH;
extensionsMap.ogg = constants_1.MediaStreamType.OGG;
extensionsMap.mkv = constants_1.MediaStreamType.MKV;
extensionsMap.mov = constants_1.MediaStreamType.MOV;
function getStreamType(url) {
    var anchorElement = document.createElement('a');
    anchorElement.href = url;
    var streamType = extensionsMap[getExtFromPath(anchorElement.pathname)];
    return streamType || false;
}
exports.getStreamType = getStreamType;
function getExtFromPath(path) {
    return path
        .split('.')
        .pop()
        .toLowerCase();
}
exports.getExtFromPath = getExtFromPath;
//# sourceMappingURL=detect-stream-type.js.map